exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tag[data-v-7b27a7de] {\n  display: flex;\n  height: 23px;\n  align-items: center;\n  border-radius: 2px;\n  padding: 6px 8px 4px;\n}\n.tag img[data-v-7b27a7de] {\n  width: 14px;\n  height: 14px;\n  margin-top: -2px;\n  margin-right: 2px;\n  vertical-align: text-top;\n}\n.tag__text[data-v-7b27a7de] {\n  color: #fff;\n  font-size: 12px;\n  text-transform: uppercase;\n  font-weight: bold;\n  line-height: initial;\n}", ""]);

// exports
